<template>
  <div class="client-appointments view row">
    <template v-if="location">
      <div class="col-12">
        <router-link :to="['/online-appointment', locationId].join('/')">
          <i class="fas fa-chevron-left" aria-hidden="true"></i>
          {{ $t('navigation.back') }}
        </router-link>
      </div>
      <div class="col-12 mt-3">
        <loading-overlay v-if="pending"/>
        <form-date-time-input
            :label="$t('choose_day.calendar.label')"
            :availableSlots="availableTimeSlots"
            :hide-time="true"
            v-model="date"
            @input="checkDate"
        />
      </div>
    </template>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {mapActions, mapState} from "vuex";

import FormInput from "pixelstein-vue-app-package/src/vue2/PsForm/PsFormInput";
import FormDateTimeInput from "@/components/FormDateTimeInput";
import LoadingOverlay from "@/components/LoadingOverlay";


export default {
  name: "ChooseDayView",
  components: {LoadingOverlay, FormDateTimeInput, FormInput},
  props: {
    appointmentTypeId: {type: String, default: null},
    locationId: {type: String, default: null},
  },
  data() {
    return {
      availableTimeSlots: [],
      pending: true,
      date: dayjs().toISOString(),
      useDefaultHeader: false
    }
  },
  computed: {
    ...mapState({
      locations: state => state.Api.Locations.all,
      appointmentTypes: state => state.Api.AppointmentTypes.all
    }),
    selectedAppointmentType() {
      return this.appointmentTypes.find(({id}) => id === this.appointmentTypeId) ?? null;
    },
    location() {
      return this.locations.find(({id}) => id === this.locationId)
    },
    duration() {
      return this.selectedAppointmentType?.duration ?? 15
    }
  },
  mounted() {
    if (!this.selectedAppointmentType) {
      this.$router.replace(['/online-appointment', this.locationId].join('/'));
      return;
    }

    this.getAvailableTimeSlots({
      date: dayjs().format(this.$config.API_DATE_TIME_FORMAT),
      id: this.locationId,
      duration: this.duration,
      all_days: true
    })
        .then(result => {
          let now = dayjs().unix();
          this.availableTimeSlots = result.filter(block => {
            return block.filter(slot => {
              return dayjs(slot.start).unix() > now
            }).length > 0
          })
          if (this.availableTimeSlots[0] && this.availableTimeSlots[0][0]) {
            this.date = this.availableTimeSlots[0][0].start
          } else {
            return Promise.reject(this.$t('choose_day.no_slots'))
          }

        })
        .catch(this.$apiErrorHandler)
        .finally(() => this.pending = false)

  },
  methods: {
    ...mapActions({
      getAvailableTimeSlots: "Api/Locations/available-slots"
    }),
    checkDate() {
      if (dayjs().unix() > dayjs(this.date).endOf('d').unix()) {
        this.date = dayjs().toISOString()
      } else {
        this.$router.push(['/online-appointment', this.locationId, this.appointmentTypeId, this.date].join('/'))
      }
    }
  }
}
</script>

